"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typeChecks_1 = require("./typeChecks");
function transform(initialValue, transforms) {
    if (!typeChecks_1.isNumber(initialValue) || transforms.find(function (transform) { return !transform || !typeChecks_1.isNumber(transform.value); })) {
        return;
    }
    return transforms.reduce(function (runningValue, transform) {
        if (typeChecks_1.isNumber(runningValue)) {
            var operator = transform.operator, order = transform.order, value = transform.value;
            var transformFunction = transformFunctions[operator];
            if (transformFunction) {
                if (!order || order === 'initialValueFirst') {
                    runningValue = transformFunction(runningValue, value);
                }
                if (order === 'initialValueLast') {
                    runningValue = transformFunction(value, runningValue);
                }
            }
        }
        return runningValue;
    }, initialValue);
}
exports.transform = transform;
var transformFunctions = {
    add: function (a, b) { return a + b; },
    subtract: function (a, b) { return a - b; },
    divide: function (a, b) {
        if (b === 0) {
            return undefined;
        }
        return a / b;
    },
    multiply: function (a, b) { return a * b; },
};
//# sourceMappingURL=transform.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/transform.js
// module id = 300
// module chunks = 1